import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://api.swaasa-app.swaasa.ai:8000/api',  //prod
  // baseURL: 'https://kas-api.swaasa.ai:8085/api',      //dev
//  baseURL: 'https://kas-api.swaasa.ai:8086/api',      //dev
//  baseURL: "https://8aff-2406-b400-d4-4efa-9c74-a283-3d20-e241.ngrok-free.app/api", //NgRok

});
// instance.defaults.headers.common['ngrok-skip-browser-warning'] = '69420';


export default instance;
 